(function (Translator) {
    // et
    Translator.add("address", "Aadress:", "PayseraMapBundle", "et");
    Translator.add("friday", "Reede", "PayseraMapBundle", "et");
    Translator.add("monday", "Esmasp\u00e4ev", "PayseraMapBundle", "et");
    Translator.add("no_results", "Tulemusi ei leitud", "PayseraMapBundle", "et");
    Translator.add("saturday", "Laup\u00e4ev", "PayseraMapBundle", "et");
    Translator.add("search_placeholder", "Sisestage fragment", "PayseraMapBundle", "et");
    Translator.add("service.cash_in", "Sissemakse", "PayseraMapBundle", "et");
    Translator.add("service.cash_out", "V\u00e4ljamakse", "PayseraMapBundle", "et");
    Translator.add("service.identification", "Identifitseerimine ", "PayseraMapBundle", "et");
    Translator.add("service.pay", "Maksed", "PayseraMapBundle", "et");
    Translator.add("services", "Teenused:", "PayseraMapBundle", "et");
    Translator.add("sunday", "P\u00fchap\u00e4ev", "PayseraMapBundle", "et");
    Translator.add("thursday", "Neljap\u00e4ev", "PayseraMapBundle", "et");
    Translator.add("tuesday", "Teisip\u00e4ev", "PayseraMapBundle", "et");
    Translator.add("wednesday", "Kolmap\u00e4ev", "PayseraMapBundle", "et");
    Translator.add("working_hours", "T\u00f6\u00f6aeg:", "PayseraMapBundle", "et");
})(Translator);
